import { API_BASE } from '../config';

export interface GuardSubscribeResponse {
  mode: 'points';
  guard_has_access: boolean;
  guard_access_until: string;
  deducted_points: number;
}

export interface GuardPaymentResponse {
  order_id: string;
  pay_url: string;
  amount: number;
  package_name: string;
}

function buildApiError(detail: string, status: number) {
  const error = new Error(detail || '请求失败');
  (error as any).response = { status, data: { detail } };
  return error;
}

export async function subscribeGuardMembership(token: string): Promise<GuardSubscribeResponse> {
  const response = await fetch(`${API_BASE}/api/guard/subscribe`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw buildApiError(payload?.detail || response.statusText || '守卫月卡开通失败', response.status);
  }

  return payload as GuardSubscribeResponse;
}

export async function createGuardPayment(token: string, payType = 'alipay'): Promise<GuardPaymentResponse> {
  const response = await fetch(`${API_BASE}/api/guard/pay/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ pay_type: payType }),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw buildApiError(payload?.detail || response.statusText || '守卫月卡支付创建失败', response.status);
  }

  return payload as GuardPaymentResponse;
}
